import { useMemo } from 'react';

import {
  toolTransform,
  collegeTransform,
  competencyTransform,
  internshipTransform,
  scholarshipTransform,
  careerPathFromMappedTransform,
  majorTransform,
  industryTransform,
  employerTransform,
  coachTransform,
  deepDiveTransform,
  playlistTransform,
} from '@backrs_ui/common-ui';

import { ContentNuggetChip } from '@backrs_ui/grow-ui/src/components/Nuggets/ContentNuggetChip';
import { useResourceData } from '@backrs_ui/grow-ui/src/hooks/useResourceData';
import { ResourceKey } from '@backrs_ui/grow-ui/src/models/models';

type AttachedNuggetChipProps = Readonly<{
  id: string;
  type: ResourceKey;
  onRemove?: () => void;
}>;

export const AttachedNuggetChip = ({ id, type, onRemove }: AttachedNuggetChipProps) => {
  const resourceData = useResourceData(type, id);

  const contentNugget = useMemo(() => {
    if (resourceData.contentNuggetData) return resourceData.contentNuggetData;
    if (resourceData.toolData) return toolTransform(resourceData.toolData);
    if (resourceData.collegeData) return collegeTransform(resourceData.collegeData);
    if (resourceData.competencyData) return competencyTransform(resourceData.competencyData);
    if (resourceData.internshipData) return internshipTransform(resourceData.internshipData);
    if (resourceData.scholarshipData) return scholarshipTransform(resourceData.scholarshipData);
    if (resourceData.careerPathData)
      return careerPathFromMappedTransform(resourceData.careerPathData);
    if (resourceData.majorData) return majorTransform(resourceData.majorData);
    if (resourceData.industryData) return industryTransform(resourceData.industryData);
    if (resourceData.employerData) return employerTransform(resourceData.employerData);
    if (resourceData.coachData) return coachTransform(resourceData.coachData);
    if (resourceData.deepDiveData) return deepDiveTransform(resourceData.deepDiveData);
    if (resourceData.suggestedPlaybookData)
      return playlistTransform(resourceData.suggestedPlaybookData);

    return null;
  }, [resourceData]);

  if (!contentNugget) {
    return null;
  }

  return (
    <ContentNuggetChip
      id={`attached-nugget-chip-${type}-${id}`}
      nugget={contentNugget}
      onRemove={onRemove}
    />
  );
};
